import React, { useContext } from "react";
import _ from "lodash";
import { Checkbox, Popper, Paper, ClickAwayListener, TextField } from "@material-ui/core";
import { DashboardContext } from "../../context/DashboardContext";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CircularProgress from "@material-ui/core/CircularProgress";
import useStoreConfig from "../../hooks/useStoreConfig";
import { UserContext } from "../../context/UserContext";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PopoverFilter = ({ filterItem, setView, query, setQuery, getFilterByKey, classStyle }) => {
  const { dashboardView } = useContext(DashboardContext);
  const { userRole } = useContext(UserContext);
  const { getIdType } = useStoreConfig();

  const title = _.get(filterItem, "title");
  const target = _.get(filterItem, "target");
  const value = _.get(filterItem, "key") === "idType" ? getIdType(_.get(filterItem, "items"), userRole, dashboardView) : _.get(filterItem, "items");
  const key = _.get(filterItem, "key");

  const handleChangeCheckbox = (event, checkBoxKey) => {
    let clonnedQuery = { ...query };
    if (_.isEmpty(clonnedQuery[dashboardView])) {
      clonnedQuery[dashboardView] = {};
    }
    let dataValue: string | Array<string> = "";
    try {
      dataValue = clonnedQuery[dashboardView][checkBoxKey];
    } catch (e) {}
    let data = _.isEmpty(dataValue) ? [] : dataValue instanceof Array ? dataValue : dataValue.split(",");
    if (event.target.checked) {
      data.push(event.target.name);
    } else {
      let index = data.indexOf(event.target.name);
      if (index > -1) {
        data.splice(index, 1);
      }
    }
    clonnedQuery[dashboardView][checkBoxKey] = filterItem.isArrayQuery ? _.uniq(data) : data.join(",");
    if (_.isEmpty(data)) {
      delete clonnedQuery[dashboardView][checkBoxKey];
    }
    setQuery(clonnedQuery);
  };
  const handleChangeAll = (event, changeAllKey) => {
    let clonnedQuery = { ...query };
    if (_.isEmpty(clonnedQuery[dashboardView])) {
      clonnedQuery[dashboardView] = {};
    }
    let dataValue: string | Array<string> = "";
    try {
      dataValue = clonnedQuery[dashboardView][changeAllKey];
    } catch (e) {}
    let data = _.isEmpty(dataValue) ? [] : dataValue instanceof Array ? dataValue : dataValue.split(",");
    if (event.target.checked) {
      data = _.values(_.mapValues(value, "value"));
    } else {
      data = [];
    }
    clonnedQuery[dashboardView][changeAllKey] = filterItem.isArrayQuery ? _.uniq(data) : _.uniq(data).join(",");
    if (_.isEmpty(data)) {
      delete clonnedQuery[dashboardView][changeAllKey];
    }
    setQuery(clonnedQuery);
  };
  const checkAllSelect = (filterKey, checkAllValue) => {
    let filterValue = _.split(filterKey, /,/g);
    let flag = false;
    if (_.isEmpty(_.compact(filterValue))) {
      flag = false;
    } else {
      flag = _.size(checkAllValue) === _.size(filterValue);
    }
    return flag;
  };

  const autoCompleteBox = () => {
    return (
      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        options={_.union([{ label: "Select all", value: "all" }], _.uniq(value))}
        value={[]}
        disableCloseOnSelect={true}
        popupIcon={null}
        clearOnEscape={true}
        open={true}
        disableClearable
        classes={{
          root: classStyle.autoComplete,
          popper: classStyle.popperAuto,
          popperDisablePortal: classStyle.popperAuto,
          listbox: classStyle.list,
          option: classStyle.option,
          inputRoot: classStyle.input,
        }}
        disablePortal={true}
        getOptionLabel={(option) => _.get(option, "label")}
        renderOption={(option, state) => {
          let selected = getFilterByKey(dashboardView, key);
          if (_.get(option, "value") === "all") {
            state.selected = checkAllSelect(getFilterByKey(dashboardView, key), _.uniq(value));
          } else {
            state.selected = _.includes(_.split(selected, /,/g), _.get(option, "value"));
          }
          return (
            <div
              style={{ width: "100%" }}
              className={classStyle.dropdown}
              onClick={(event) => {
                if (_.get(option, "value") === "all") {
                  event.target["checked"] = !checkAllSelect(getFilterByKey(dashboardView, key), _.uniq(value));
                  handleChangeAll(event, key);
                } else {
                  event.target["checked"] = !state.selected;
                  event.target["name"] = _.get(option, "value");
                  handleChangeCheckbox(event, key);
                }
              }}>
              <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={state.selected} color="primary" />
              {_.get(option, "label")}
            </div>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
            placeholder="Search"
          />
        )}
      />
    );
  };

  return (
    <Popper
      key={"Popover" + title}
      id={"Popover" + title}
      open={Boolean(target)}
      anchorEl={target}
      className={classStyle.popper}
      modifiers={{
        preventOverflow: { escapeWithReference: false },
      }}
      keepMounted
      disablePortal
      popperOptions={{ positionFixed: true }}
      placement={"bottom"}>
      <ClickAwayListener
        key={"clickaway" + title}
        onClickAway={(e) => {
          e.preventDefault();
          setView(null);
        }}>
        <Paper className={classStyle.paperAuto}>
          {_.isEmpty(value) ? (
            <div style={{ padding: "10px 15px" }}>
              {" "}
              Loading <CircularProgress size={20} />
            </div>
          ) : (
            autoCompleteBox()
          )}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default React.memo(PopoverFilter);
